import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../config/config";
import { apiConstants } from "../constant/apiConstant";

export interface ParentAcademicEvent {
  eventName: string;
  startDate: string;
  endDate: string;
  colorCode: string;
  description: string;
}

export interface GetParentEventInfoResponse {
  status: boolean;
  message?: string;
  body?: {
    eventList: ParentAcademicEvent[];
  };
}

@Injectable({ providedIn: 'root' })
export class ParentAcademicCalendarService {
  private url = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) {}

  getEventInfo(classId: string, studentId: string, startDate: string, endDate: string) {
    const params = new HttpParams()
      .set('lang', 'en')
      .set('startDate', startDate)
      .set('endDate', endDate)
      .set('classId', classId)
      .set('studentId', studentId);
    return this.http
      .get<GetParentEventInfoResponse>(this.url + apiConstants.getParentAcademicCalendarEvents, { params })
      .pipe(map((res) => res));
  }
}
